import { Link } from "react-router-dom"
import * as React from "react"
import { Container } from "react-bootstrap"
import { Layout } from "../../components/layout"
import { Head } from "../../components/seo"

export const TimehuntPrivacyPolicyPage = () => (
  <Layout title="timehunt" subtitle="プライバシーポリシー Privacy policy">
    <Head title="timehunt Privacy Policy" />
    <div className="my-4">
      <Container className="my-4">
        <p>ご利用者のカレンダーから、いかなる情報も収集および配布しません。</p>
        <p>We do not collect or distribute any information from your calendar.</p>
        <div className="text-center mt-5">
          <Link to="/products">戻る Back</Link>
        </div>
      </Container>
    </div>
  </Layout>
)